"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.processMeta = exports.memberTypes = exports.hasMinimalInfo = exports.hasContactInfo = exports.getStructuredData = exports.getMemberTitle = exports.getMemberPhones = exports.getContactInfo = exports.agentUrl = void 0;
exports.sortAgents = sortAgents;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _flat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _reverse = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reverse"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _string = require("@raywhite/helpers-utils/lib/helpers/string");
var _sanitization = require("@raywhite/helpers-utils/lib/helpers/sanitization");
var _structuredData = require("@raywhite/helpers-utils/lib/helpers/structuredData");
var agentUrl = (member, section) => {
  var _context, _context2;
  var {
    fullName,
    id,
    memberId
  } = member;
  var base = (0, _concat.default)(_context = "/agents/".concat((0, _string.toSlug)(fullName), "/")).call(_context, id || memberId);
  return section ? (0, _concat.default)(_context2 = "".concat(base, "/")).call(_context2, section) : base;
};

/**
 * Find the contact information for an agent, in the context of the provided
 * organisation ID if required, and falling back to any organisation ID favouring
 * their primary org ID if fallback is set.
 */
exports.agentUrl = agentUrl;
var getContactInfo = function (member) {
  var _context3, _context4, _context5, _context6;
  var {
    fallback = true,
    orgId
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!orgId && !fallback) throw new Error('An orgId must be specified if fallback is disabled');
  var {
    email
  } = member;
  var phones = (0, _find.default)(_context3 = (0, _filter.default)(_context4 = (0, _flat.default)(_context5 = [
  // Prioritise the requested org ID
  orgId ? member.phones[orgId] : false,
  // Include all orgs' phones, prioritising primary, if fallback requested
  fallback ? (0, _map.default)(_context6 = member.organisationIds).call(_context6, oid => (member === null || member === void 0 ? void 0 : member.phones[oid]) || false) : false]).call(_context5)).call(_context4, Boolean)).call(_context3, ph => ph.mobilePhone || ph.officePhone || ph.promoPhone);
  var {
    mobilePhone,
    officePhone,
    promoPhone
  } = phones || {};
  return {
    email,
    mobilePhone,
    officePhone,
    promoPhone
  };
};
exports.getContactInfo = getContactInfo;
var hasContactInfo = (member, options) => {
  var info = getContactInfo(member, options);
  return Boolean(info.email || info.mobilePhone || info.officePhone);
};
exports.hasContactInfo = hasContactInfo;
var hasMinimalInfo = (member, options) => Boolean(member.fullName) && hasContactInfo(member, options);
exports.hasMinimalInfo = hasMinimalInfo;
var memberTypes = exports.memberTypes = ['OFST', 'OFSA', 'CORP', 'CORSA'];
var getMemberTitle = (organisationIds, titles, memberOrgIds) => {
  if (!organisationIds) return undefined;
  // eslint-disable-next-line no-restricted-syntax
  for (var id of memberOrgIds) {
    if ((0, _indexOf.default)(organisationIds).call(organisationIds, id) !== -1) return titles[id];
  }
  return undefined;
};
exports.getMemberTitle = getMemberTitle;
var noundef = obj => {
  var _context7;
  return (0, _reduce.default)(_context7 = (0, _entries.default)(obj)).call(_context7, (acc, _ref) => {
    var [k, v] = _ref;
    if (v === undefined) return acc;
    acc[k] = v;
    return acc;
  }, {});
};
var getMemberPhones = (organisationIds, phones, memberOrgIds) => {
  var _context8, _context9, _context10, _context11, _context12;
  if (!organisationIds) return undefined;
  var siteOrgIds = (0, _reduce.default)(organisationIds).call(organisationIds, (acc, id) => {
    acc[id] = true;
    return acc;
  }, {});
  return (0, _reduce.default)(_context8 = (0, _map.default)(_context9 = (0, _filter.default)(_context10 = (0, _map.default)(_context11 = (0, _reverse.default)(_context12 = (0, _filter.default)(memberOrgIds).call(memberOrgIds, id => siteOrgIds[id])).call(_context12)).call(_context11, id => phones[id])).call(_context10, Boolean)).call(_context9, noundef)).call(_context8, (acc, p) => ({
    ...acc,
    ...p
  }), {});
};
exports.getMemberPhones = getMemberPhones;
var getStructuredData = (data, office, baseUrl) => {
  var _context13, _context14, _context15;
  var {
    description,
    email,
    facebook,
    fullName,
    givenName,
    googlePlus,
    image,
    imageHeadshot,
    imageLifestyle,
    instagram,
    linkedin,
    mobilePhone,
    officePhone,
    pinterest,
    promoPhone,
    surname,
    title,
    twitter,
    youtube
  } = data;
  var _description = description || (0, _filter.default)(_context13 = [title, office.fullName]).call(_context13, x => !!x).join(' - ');
  var agentImage = imageLifestyle || imageHeadshot || image;
  return (0, _structuredData.person)({
    name: (0, _filter.default)(_context14 = [fullName, office && office.fullName]).call(_context14, x => !!x).join(' - '),
    url: baseUrl && (0, _concat.default)(_context15 = "".concat(baseUrl)).call(_context15, agentUrl(data)),
    description: (0, _sanitization.plainText)(_description),
    givenName,
    familyName: surname,
    telephone: promoPhone || mobilePhone || officePhone,
    email,
    jobTitle: title,
    image: agentImage && "".concat(agentImage, "?maxwidth=1280"),
    sameAs: [facebook, twitter, googlePlus, youtube, linkedin, pinterest, instagram]
  });
};

/**
 * Processes agent listing metadata to build a list of categories and queries
 * for showing those listings.
 */
exports.getStructuredData = getStructuredData;
var processMeta = meta => {
  var _context16;
  if (!meta.loaded) return {};

  // Queries which are used to display agent listings
  var queries = {
    Sold: {
      statusCode: ['SLD'],
      sort: ['soldDate desc', 'id desc']
    },
    'For Sale': {
      statusCode: ['CUR'],
      typeCode: ['SAL', 'COM', 'BUS', 'RUR', 'LVS'],
      subTypeCode: {
        not: ['LSE']
      },
      sort: 'updatedAt desc'
    },
    Leased: {
      statusCode: ['LSE'],
      sort: 'updatedAt desc'
    },
    'For Rent': {
      statusCode: ['CUR'],
      typeCode: ['REN', 'HOL'],
      sort: 'updatedAt desc'
    },
    'For Lease': {
      statusCode: ['CUR'],
      typeCode: ['COM'],
      subTypeCode: {
        not: ['SAL']
      },
      sort: 'updatedAt desc'
    },
    Other: {
      statusCode: ['CUR'],
      typeCode: ['ALP', 'LVW', 'CLR'],
      sort: 'updatedAt desc'
    }
  };
  var listings = {};
  (0, _forEach.default)(_context16 = (0, _entries.default)(meta)).call(_context16, _ref2 => {
    var _context17;
    var [typeCode, data] = _ref2;
    if (!/^[A-Z]{3}$/.test(typeCode)) return;
    var {
      statusCode: statuses = {},
      subTypeCode: subtypes = {}
    } = data;
    if (statuses.SLD) listings.Sold = queries.Sold;
    if (statuses.LSE) listings.Leased = queries.Leased;
    if (statuses.CUR) {
      switch (typeCode) {
        case 'SAL':
        case 'RUR':
        case 'LVS':
        case 'BUS':
          listings['For Sale'] = queries['For Sale'];
          break;
        case 'REN':
        case 'HOL':
          listings['For Rent'] = queries['For Rent'];
          break;
        case 'LVW':
        case 'CLS':
        case 'ALP':
          listings.Other = queries.Other;
          break;
        default:
        // Do nothing
      }
    }
    (0, _forEach.default)(_context17 = (0, _entries.default)(subtypes)).call(_context17, _ref3 => {
      var [subTypeCode, _data] = _ref3;
      // SLD/LSE already processed above
      if (!_data.statusCode.CUR) return;
      switch (subTypeCode) {
        case 'SAL':
          listings['For Sale'] = queries['For Sale'];
          break;
        case 'LSE':
          listings['For Lease'] = queries['For Lease'];
          break;
        case 'BOTH':
          listings['For Sale'] = queries['For Sale'];
          listings['For Lease'] = queries['For Lease'];
          break;
        default:
        // Should not happen
      }
    });
  });

  // Merge for lease and for rent together if both are present
  if (listings['For Rent'] && listings['For Lease']) {
    var rent = listings['For Rent'];
    var lease = listings['For Lease'];
    rent.typeCode.push(...lease.typeCode);
    rent.subTypeCode = lease.subTypeCode;
    delete listings['For Lease'];
  }
  return listings;
};

/**
 * A sort function for Array.sort to sort agents into a sane default order, which
 * is principals first, then the rest, each set sorted alphabetically by surname
 * then given name.
 */
exports.processMeta = processMeta;
function sortAgents(a, b) {
  var ap = a.isPrincipal;
  var bp = b.isPrincipal;

  // If one is a principal and another not, put the principal first
  if (ap && !bp) return -1;
  if (!ap && bp) return 1;

  // Otherwise sort alphabetially by surname
  if (a.surname < b.surname) return -1;
  if (a.surname > b.surname) return 1;

  // Otherwise sort alphabetially by firstname
  if (a.givenName < b.givenName) return -1;
  if (a.givenName > b.givenName) return 1;
  return 0;
}